<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      no-body
      class="text-center mt-2"
      header="Cikk szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <!-- <b-row class="container mt-2">
        <b-col md="2">
          <div class="form-group">
            <label for="beszerdatum">Beszerzés dátuma</label>
            <b-form-input
              size="sm"
              type="date"
              v-model="list.beszerdatum"
              class="form-control"
              id="beszerdatum"
            />
          </div>
        </b-col>
        <b-col md="2">
          <div class="form-group">
            <label for="garancia">Garancia</label>
            <b-form-input
              size="sm"
              type="text"
              v-model="list.garancia"
              class="form-control"
              id="garancia"
            />
          </div>
        </b-col>
        <b-col md="2">
          <div class="form-group">
            <label for="mennyiseg">Mennyiség</label>
            <b-form-input
              size="sm"
              type="text"
              v-model="list.mennyiseg"
              class="form-control"
              id="mennyiseg"
            />
          </div>
        </b-col>
      </b-row> -->

      <b-card-body class="text-left">
        <div class="col-sm-">
          <div class="row-fluid">

            <!-- // FORM -->
            <b-form>
            <!-- <b-form @submit="addElement"> -->

              <b-form-group label="Megnevezés" label-for="nev" label-cols-sm="3" label-align-sm="left">
                <b-form-input required size="sm" type="text" v-model="list.nev" class="form-control" id="nev"></b-form-input>
              </b-form-group>

              <b-form-group  label="Gyártó" label-for="gyartok" label-cols-sm="3" label-align-sm="left">
                <b-form-select v-model="gyartokSelect" :options="gyartokList" size="sm" id="gyartok"></b-form-select>
              </b-form-group>

              <b-form-group  label="Cikkcsoport" label-for="cikkcsoport" label-cols-sm="3" label-align-sm="left">
                <b-form-select v-model="cikkcsoportSelect" :options="cikkcsoportList" size="sm" id="cikkcsoport"></b-form-select>
              </b-form-group>

              <b-form-group  label="Vonalkód" label-for="vonalkod" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.vonalkod" class="form-control" id="vonalkod"></b-form-input>
              </b-form-group>

              <b-form-group  label="Cikkszám" label-for="cikkszam" label-cols-sm="3" label-align-sm="left">
                <b-form-input @keydown.enter="a" size="sm" type="text" v-model="list.cikkszam" class="form-control" id="cikkszam"></b-form-input>
              </b-form-group>

              <b-form-group  label="Mennyiségi egység" label-for="mennyisegiegyseg" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.mennyisegiegyseg" class="form-control" id="mennyisegiegyseg"></b-form-input>
              </b-form-group>

              <b-form-group  label="Nettó beszerzési ár" label-for="nettobeszar" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.nettobeszar" class="form-control" id="nettobeszar"></b-form-input>
              </b-form-group>

              <b-form-group  label="Nettó fogyasztási ár" label-for="bruttofogyar" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.bruttofogyar" class="form-control" id="bruttofogyar"></b-form-input>
              </b-form-group>

              <b-form-group  label="Készleten" label-for="Készleten" label-cols-sm="3" label-align-sm="left">
                <b-form-input size="sm" type="text" v-model="list.mennyiseg" class="form-control" id="mennyiseg"></b-form-input>
              </b-form-group>

              <b-form-group  label="Gyáriszámsos termék" label-for="cikkszam" label-cols-sm="3" label-align-sm="left">
                <b-form-checkbox
                  id="gyariszamos"
                  v-model="list.gyariszamos"
                  name="gyariszamos"
                  value="1"
                  unchecked-value="0"
                >
                  Minden termékhez külön gyáriszám tartozik
                </b-form-checkbox>
              </b-form-group>

              <!-- // SAVE -->
              <b-button variant="primary" @click="addElement">
                <b-icon-cloud-upload></b-icon-cloud-upload>
                Mentés</b-button>

              <!-- // CANCEL -->
              <b-button
                variant="outline-danger"
                class="float-right"
                @click="$router.push({name: 'Cikkek'})"
                ><b-icon-arrow-left></b-icon-arrow-left>
                Mégsem</b-button
              >
            </b-form>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      gyartokList: [],
      gyartokSelect: [],
      cikkcsoportList: [],
      cikkcsoportSelect: [],
      list: {}
    }
  },
  methods: {
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = this.list.id
        payload.nev = this.list.nev
        payload.mennyisegiegyseg = this.list.mennyisegiegyseg
        payload.gyartoid = this.gyartokSelect.id
        payload.csikcsoportid = this.cikkcsoportSelect.id
        payload.vonalkod = this.list.vonalkod
        payload.cikkszam = this.list.cikkszam
        payload.nettobeszar = this.list.nettobeszar
        payload.bruttofogyar = this.list.bruttofogyar
        payload.mennyiseg = this.list.mennyiseg
        payload.gyariszamos = this.list.gyariszamos
        payload.hidden = 1
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post('http://' + process.env.ROOT_API + '/cikkek/save', { payload })
          .then(res => {
            this.$router.push({ name: 'Cikkek' })
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    loadList () {
      let id = this.$route.params.id
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = id
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post('http://' + process.env.ROOT_API + '/cikkek/edit', { payload })
          .then(res => {
            this.list = res.data
            this.gyartokSelect = res.data.gyartoModel
            this.cikkcsoportSelect = res.data.csikkCsoportModel
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      if (this.$route.params.id) {
        this.loadList()
      }
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      axios
        .post('http://' + process.env.ROOT_API + '/gyartok/getlist', { payload })
        .then(res => {
          console.log(res.data)
          for (var el in res.data) {
            this.gyartokList.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
      axios
        .post('http://' + process.env.ROOT_API + '/cikkcsoport/getlist', { payload })
        .then(res => {
          console.log(res.data)
          for (var el in res.data) {
            this.cikkcsoportList.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CikkekNew.vue